import React from "react";
import styles from "./DealerDeliveryRanges.module.scss";
import UpperCaseText from "../../../../utils/UpperCaseText";

const DeliveryRangeHeader = (props) => {
  return (
    <>
      <div
        id="businessSettingsHeader"
        className={`${styles.businessSettings} pagePaddingRight pagePaddingLeft`}
      >
        <p>{props.header}</p>
        <p>{props.t("dealerDeliveryBands.header2")}</p>
      </div>

      <div
        className={`${styles.lineNumber} pagePaddingLeft pagePaddingBottom`}
        id="businessSettingsSubHeader"
      >
        {`${UpperCaseText(props.user.market)} ${props.t(
          "dealerDeliveryBands.mainlandBands"
        )}`}
      </div>
    </>
  );
};

export default DeliveryRangeHeader;
